import { environment } from '~app/environment';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';

import { ampli } from '../../ampli';

// Initialize ampli
ampli.load({
  client: {
    apiKey: environment.AMPLITUDE_ANALYTICS_KEY,
    configuration: {
      autocapture: false,
      appVersion: environment.APP_VERSION,
    },
  },
});
ampli.client.setUserId(findOrCreateWuid());

export const analytics = {
  track: {
    calculatorOpened: (merchantUrl?: string) => {
      ampli.calculatorOpened({
        wuid: findOrCreateWuid(),
        merchant_url: merchantUrl,
      });
    },
    applicationCreated: (applicationId: string, merchantUrl?: string) => {
      ampli.applicationCreated({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
        merchant_url: merchantUrl,
      });
    },
    webApplicationFinished: (applicationId: string, merchantUrl?: string) => {
      ampli.webApplicationFinished({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
        merchant_url: merchantUrl,
      });
    },
    ponApplicationBasicInfoNextClick: (applicationId: string) => {
      ampli.ponApplicationBasicInfoNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationBasicInfoView: (applicationId: string) => {
      ampli.ponApplicationBasicInfoView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationBusinessDetailsNextClick: (applicationId: string) => {
      ampli.ponApplicationBusinessDetailsNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationBusinessDetailsView: (applicationId: string) => {
      ampli.ponApplicationBusinessDetailsView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationContactReferenceNextClick: (applicationId: string) => {
      ampli.ponApplicationContactReferenceNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationContactReferenceView: (applicationId: string) => {
      ampli.ponApplicationContactReferenceView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationCurrentAddressNextClick: (applicationId: string) => {
      ampli.ponApplicationCurrentAddressNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationCurrentAddressView: (applicationId: string) => {
      ampli.ponApplicationCurrentAddressView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationEmploymentDetailsNextClick: (applicationId: string) => {
      ampli.ponApplicationEmploymentDetailsNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationEmploymentDetailsView: (applicationId: string) => {
      ampli.ponApplicationEmploymentDetailsView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationEmploymentNextClick: (applicationId: string) => {
      ampli.ponApplicationEmploymentNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationEmploymentView: (applicationId: string) => {
      ampli.ponApplicationEmploymentView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationFinancialInfoNextClick: (applicationId: string) => {
      ampli.ponApplicationFinancialInfoNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationFinancialInfoView: (applicationId: string) => {
      ampli.ponApplicationFinancialInfoView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationHaveOutstandingDebtClick: (applicationId: string) => {
      ampli.ponApplicationHaveOutstandingDebtClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycMainIdNumberView: (applicationId: string) => {
      ampli.ponApplicationKycMainIdNumberView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycMainIdNumberNextClick: (applicationId: string) => {
      ampli.ponApplicationKycMainIdNumberNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycAdditionalIdNumberNextClick: (applicationId: string) => {
      ampli.ponApplicationKycAdditionalIdNumberNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycAdditionalIdNumberView: (applicationId: string) => {
      ampli.ponApplicationKycAdditionalIdNumberView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycIdSelectionNextClick: (applicationId: string) => {
      ampli.ponApplicationKycIdSelectionNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycIdSelectionSecondaryNextClick: (applicationId: string) => {
      ampli.ponApplicationKycIdSelectionSecondaryNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycIdSelectionView: (applicationId: string) => {
      ampli.ponApplicationKycIdSelectionView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationKycNoPrimaryIdClick: (applicationId: string) => {
      ampli.ponApplicationKycNoPrimaryIdClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationPermanentAddressNextClick: (applicationId: string) => {
      ampli.ponApplicationPermanentAddressNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationPermanentAddressDiffersFromCurrentClick: (
      applicationId: string
    ) => {
      ampli.ponApplicationPermanentAddressDiffersFromCurrentClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationPermanentAddressView: (applicationId: string) => {
      ampli.ponApplicationPermanentAddressView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationPersonalDetailsNextClick: (applicationId: string) => {
      ampli.ponApplicationPersonalDetailsNextClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponApplicationPersonalDetailsView: (applicationId: string) => {
      ampli.ponApplicationPersonalDetailsView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponBlockActiveApplicationView: () => {
      ampli.ponBlockActiveApplicationView({
        wuid: findOrCreateWuid(),
      });
    },
    ponBlockActiveLoanView: () => {
      ampli.ponBlockActiveLoanView({
        wuid: findOrCreateWuid(),
      });
    },
    ponBlockCooldownView: () => {
      ampli.ponBlockCooldownView({
        wuid: findOrCreateWuid(),
      });
    },
    ponBlockInvalidPhoneView: () => {
      ampli.ponBlockInvalidPhoneView({
        wuid: findOrCreateWuid(),
      });
    },
    ponBlockOrderExpired: () => {
      ampli.ponBlockOrderExpired({
        wuid: findOrCreateWuid(),
      });
    },
    ponBlockSubmittedApplicationView: () => {
      ampli.ponBlockSubmittedApplicationView({
        wuid: findOrCreateWuid(),
      });
    },
    ponRedirectToAppClick: (applicationId?: string) => {
      ampli.ponRedirectToAppClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponRedirectToAppView: (applicationId: string) => {
      ampli.ponRedirectToAppView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponScoringRejectedView: (applicationId: string) => {
      ampli.ponScoringRejectedView({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
    ponScoringRejectedWhyClick: (applicationId: string) => {
      ampli.ponScoringRejectedWhyClick({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
      });
    },
  },
};
